import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';

export const SuccessCallout = ({ children }) => {
    return (
        <div
            className={cn([
                'tw-flex tw-items-start tw-gap-[12px] tw-p-[16px] tw-font-[500] tw-rounded-[8px]',
                'tw-text-black tw-bg-[#E7F1E0] tw-border tw-border-[#6DAE43]'
            ])}
        >
            <img src='/assets/images/check-circle-green.svg' title='criminal record checked' alt='check-circle' />
            {children}
        </div>
    );
};

SuccessCallout.propTypes = {
    children: PropTypes.node.isRequired
};
